import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
const failures = [{
  title: 'Generic Google searches',
  desc: 'Outdated recipes missing dosages + safety (dangerous)'
}, {
  title: 'Expensive supplements ($30–$60/month)',
  desc: "12 ingredients you don't need"
}, {
  title: 'Doctors prescribe meds',
  desc: 'Mask symptoms without root cause (return next month)'
}, {
  title: "'Natural' gurus sell courses ($197+)",
  desc: 'Instead of simple kitchen fixes'
}, {
  title: 'Books with 50 vague remedies',
  desc: 'Instead of your exact symptom matched to 3 prep methods'
}];
export function FailedSolutions() {
  return <section className="py-20 bg-[#faf8f0]" data-id="element-1">
      <div className="max-w-4xl mx-auto px-4 sm:px-6" data-id="element-2">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-3">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1a3c2a] mb-6" data-id="element-4">
            Why What You've Tried Didn't Work
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-5">
          {failures.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-center gap-4 bg-white p-6 rounded-lg shadow-sm border-l-4 border-[#ef4444]" data-id="element-6">
              <XCircle className="w-6 h-6 text-[#ef4444] shrink-0" data-id="element-7" />
              <div data-id="element-8">
                <span className="font-bold text-[#1a3c2a] block md:inline md:mr-2" data-id="element-9">
                  {item.title}
                </span>
                <span className="text-[#5c4a32] md:border-l md:border-gray-300 md:pl-2" data-id="element-10">
                  {item.desc}
                </span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}